import { createSlice } from "@reduxjs/toolkit";
import { fetchReadyForDispatch } from "./thunk";

interface ReadyForDispatchState {
  list: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
}

const initialState: ReadyForDispatchState = {
  list: [],
  rowCount: 0,
  loading: false,
  error: null,
};

const ReadyForDispatchSlice = createSlice({
  name: "ReadyForDispatch",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchReadyForDispatch.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchReadyForDispatch.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchReadyForDispatch.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.error.message ||
          "Failed to fetch Ready For Dispatch List";
      });
  },
});

export default ReadyForDispatchSlice.reducer;
